export const pkg = {
  name: 'isomorphic-git',
  version: '1.37.2',
  agent: 'git/isomorphic-git@1.37.2',
}
